import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import { AuthenticationContext } from '../../../contexts/authentication';
import './NavigationBar.css';

const NavigationBar = () => {

    const { isLoggedIn } = useContext(AuthenticationContext)

    if(!isLoggedIn) return null;

    return (
        <nav className='navigation-bar'>
            <div className='navigation-bar-container'>
                {/* Logo/Brand Section */}
                <div className='navigation-bar-brand'>
                    <div className='brand-icon'>
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            viewBox="0 0 24 24" 
                            fill="currentColor"
                            width="28"
                            height="28"
                        >
                            <path d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H4V5h16v14zM6 7h12v2H6zm0 4h12v2H6zm0 4h8v2H6z"/>
                        </svg>
                    </div>
                    <span className='brand-text'>Admin Panel</span>
                </div>

                {/* Navigation Links - Left */}
                <div className='navigation-bar-left'>
                    <NavLink 
                        to="/jobs" 
                        className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                    >
                        <span className='nav-icon'>📋</span>
                        <span className='nav-text'>Jobs</span>
                    </NavLink>
                    
                    <NavLink 
                        to="/inventory" 
                        className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                    >
                        <span className='nav-icon'>📦</span>
                        <span className='nav-text'>Inventory</span>
                    </NavLink>
                    
                    <NavLink 
                        to="/schedule" 
                        className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                    >
                        <span className='nav-icon'>📅</span>
                        <span className='nav-text'>Schedule</span>
                    </NavLink>

                    <NavLink 
                        to="/crew?filterBy=active" 
                        className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                    >
                        <span className='nav-icon'>👥</span>
                        <span className='nav-text'>Crew</span>
                    </NavLink>
                </div>

                {/* Navigation Links - Right */}
                <div className='navigation-bar-right'>
                    <NavLink 
                        to="/logout" 
                        className={({ isActive }) => isActive ? 'nav-link logout-link active' : 'nav-link logout-link'}
                    >
                        <span className='nav-icon'>🚪</span>
                        <span className='nav-text'>Logout</span>
                    </NavLink>
                </div>
            </div>
        </nav>
    )
}

export default NavigationBar;
